import { render, staticRenderFns } from "./NewCertificateTypeSidebar.vue?vue&type=template&id=9b89b45e&scoped=true"
import script from "./NewCertificateTypeSidebar.vue?vue&type=script&lang=js"
export * from "./NewCertificateTypeSidebar.vue?vue&type=script&lang=js"
import style0 from "./NewCertificateTypeSidebar.vue?vue&type=style&index=0&id=9b89b45e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b89b45e",
  null
  
)

export default component.exports